import React from 'react';
import logo from './logo.svg';
import './App.css';
import './components/VideoRank.js'
import VideoRank from './components/VideoRank';

function App() {
  return (
    <div className="App">
      <h1>YT Video Rank Checker</h1>
      <VideoRank/>
    </div>
  );
}

export default App;
